import { AppTextService } from '@fi-shared/app-text';
import { createMap } from '@fi-shared/utils/create-map';

export enum fiBasicUsageChargeType {
    User = 1,
    Unit = 2,
}

export const fiBasicUsageChargeTypes = [
    {
        Id: fiBasicUsageChargeType.User,
        TextId: 'user.user',
    },
    {
        Id: fiBasicUsageChargeType.Unit,
        TextId: 'billing.unit',
    },
];

const fiBasicUsageChargeTypesMap = createMap(fiBasicUsageChargeTypes, 'Id');
export function fiBasicUsageChargeTypeName(chargingType: fiBasicUsageChargeType, appText: AppTextService) {
    if (fiBasicUsageChargeTypesMap.hasOwnProperty(chargingType))
        return appText.get(fiBasicUsageChargeTypesMap[chargingType].TextId);

    throw 'FI: Unknown charging type ' + chargingType;
}
